<template>
    <div class="page-classes h-full bg-black text-white group" :class="last?.zoom >= 8 ? 'is-zoomed-in' : ''">
        <div class="absolute w-full bottom-0 z-8000 text-center" v-show="home">
            <layout-contained>
                <nuxt-link
                    to="/contact"
                    class="inline-block mx-auto py-1 px-3 mb-3 md:mb-4 bg-white/40 hover:bg-white rounded-full border border-zinc-500/30 hover:border-zinc-500"
                >
                    <span class="text-sm text-black tracking-tight leading-5"
                        >Class missing? Click here to let us know!</span
                    >
                </nuxt-link>
            </layout-contained>
        </div>
        <section-map v-show="home"></section-map>
        <section-text
            v-if="!home"
            padding="py-6"
            color="bg-black"
            content="<p>Loading the map...</p>"
            contentColor="text-zinc-300"
        >
            <template v-slot:custom>
                <noscript>
                    <div class="pt-2" v-if="classes?.length">
                        <div v-for="item in classes" :key="item.id_class">
                            <nuxt-link class="text-zinc-400" :to="'/classes/' + item.class_slug">{{
                                item.class_name
                            }}</nuxt-link>
                        </div>
                    </div>
                </noscript>
            </template>
        </section-text>
    </div>
</template>

<script setup>
const {classes} = storeToRefs(useStoreClasses());
const {initClasses} = useStoreClasses();

const {home, last} = storeToRefs(useStoreMap());

if (import.meta.server) {
    await useLazyAsyncData('initClasses', () => initClasses().then(() => true));
}

const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Classes | West Coast Swing',
    description: 'A map of West Coast Swing classes across the world.',
    image: $config.public.images + 'west-coast-swing-classes.jpg',
    index: true,
});
</script>
